
function fetchConfig(type = 'json', contentType = 'json') {
  return {
    method: 'POST',
    headers: { 'Content-Type': `application/${contentType}`, 'Accept': `application/${type}` }
  };
}

class KlaviyoNewsletter extends HTMLElement {

  constructor() {
    super();

    // Options
    this.options = {
      klaviyoListID: "1234",
      redirectDelay: 5000,
      successTitle: "",
      successMessage: "",
      termsError: "",
      emptyError: "",
      subscribeError: ""
    };

    // Get options from element data and combine with this.options
    if (this?.dataset?.options) {
      const dataOptions = JSON.parse(this.dataset.options);
      this.options = {
        ...this.options,
        ...dataOptions
      };
    }

    this.inputInvalidAttribute = 'aria-invalid';
    this.titleElement = this.querySelector('[data-klaviyo-newsletter-title]');
    this.description = this.querySelector('[data-klaviyo-newsletter-description]');
    this.form = this.querySelector('[data-klaviyo-newsletter-form]');
    this.formInput = this.querySelector('[data-klaviyo-newsletter-form-input]');
    this.formSubmit = this.querySelector('[data-klaviyo-newsletter-form-submit]');
    this.formCheckbox = this.querySelector('[data-klaviyo-newsletter-form-checkbox]');
    this.errorMessage = this.querySelector('[data-klaviyo-newsletter-error-message]');

    // Construct webcomponent
    this.construct();
  }

  /*
    Construct webcomponent
  */
  construct() {

    // Guard: Check if form is available
    if (!this.form) {
      return false;
    }

    // On submit of the form
    this.form.addEventListener('submit', (event) => {
      event.preventDefault();
      this.handleFormSubmit();
    });
  }

  /**
   * Handle the klaviyo form submit
   * @returns void
   */
   handleFormSubmit() {
    const email = this.formInput.value.trim();

    // Clear all form messages first
    this.clearFormErrorMessage();
    this.clearInputValidation();

    // Validate email input before continuing
    // Email validation regex as implemented in the HTML5 input of type email
    const emailRegEx = /^[a-zA-Z0-9.!#$%&’*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

    // Check if terms need to be accepted
    if (this.formCheckbox) {
      if (!this.formCheckbox.checked) {
        this.updateFormErrorMessage(this.options.termsError);
        return false;
      }
    }

    // Check email format
    if (!emailRegEx.test(email)) {
      this.updateFormErrorMessage(this.options.emptyError);
      this.formInput.setAttribute(this.inputInvalidAttribute, true);
      return false;
    }

    // Handle the klaviyo fetch request
    this.handleKlaviyoRequest(email);
  }

  /**
   * Handle the klaviyo fetch request
   * @returns void
   */
   handleKlaviyoRequest(email) {

    const endpoint = 'https://manage.kmail-lists.com/ajax/subscriptions/subscribe';
    const options = {
      "g": this.options.klaviyoListID,
      "email": email
    };

    // Enable button again
    this.formSubmit.classList.add('loading');
    this.formSubmit.disabled = true;

    fetch(endpoint, {
      ...fetchConfig('json', 'x-www-form-urlencoded'),
      body: new URLSearchParams(options),
    })
    .then((response) => {

      if (response.status !== 200) {
        throw new Error(response.status);
      }

      // On success: handle the successful submit
      this.handleSuccessSubmit();
    })
    .catch((error) => {
      // On error:
      console.error('Klaviyo popup: Error submitting email to list', error);
      this.formSubmit.disabled = false;
      this.updateFormErrorMessage(this.options.subscribeError);
    })
    .finally(() => {
      // Enable button again
      this.formSubmit.classList.remove('loading');
    });
  }

  /**
   * Handle Success Submit
   * @returns void
   */
  handleSuccessSubmit() {

    // Update the title and success message
    this.titleElement.innerHTML = this.options.successTitle;
    this.showFormSuccessMessage(this.options.successMessage);

    // Hide the form
    this.form.classList.add('visually-hidden');

    // Redirect to homepage
    setTimeout(() => {
      document.location.href = '/';
    }, this.options.redirectDelay);
  }

  /**
   * Update form message
   * @returns void
   */
  updateFormErrorMessage(message) {
    this.errorMessage.innerHTML = message;
  }

  /**
   * Clear form message
   * @returns void
   */
  clearFormErrorMessage() {
    this.errorMessage.innerHTML = '';
  }

  /**
   * Show the form success message
   * @returns void
   */
  showFormSuccessMessage(message) {
    const messageFormat = message.replace('[email]', this.formInput.value);
    this.description.innerHTML = messageFormat;
  }

  /**
   * Clear inout validation
   * @returns void
   */
  clearInputValidation() {
    if (this.formInput.getAttribute(this.inputInvalidAttribute) === 'true') {
      this.formInput.removeAttribute(this.inputInvalidAttribute);
    }
  }

}

if (!customElements.get('klaviyo-newsletter')) {
  customElements.define('klaviyo-newsletter', KlaviyoNewsletter);
}
